import $ from 'jquery';
import DataTable from '@/lib/datatable.js';
import ExportActionDropdown from '@/lib/components/Exports/ExportActionDropdown.vue';
import SavedViewsList from '@/modules/search/components/SavedViewsList.vue';
import SaveViewForm from '@/modules/search/components/SaveViewForm.vue';
import store from '@/lib/store';
import Vue from 'vue';

/**
 * Setup base components on the index view.
 *
 * Usage:
 *   new IndexView();
 *
 */
let datatable;

export default function () {
	// Hacky way to move the initialization in the end of the event loop (start of the next event loop)
	process.nextTick(function () {
		datatable = new DataTable();
		datatable.setup('.datatable');
	});

	let savedViewsList, saveViewForm;

	$('.filtertron-tray').filtertronTray({
		onOpen: function () {
			datatable.refresh();

			if (!savedViewsList && !saveViewForm) {
				if ($('.save-view-form').length) {
					saveViewForm = new Vue({
						el: '.save-view-form',
						name: 'SaveViewFormApp',
						components: {
							SaveViewForm,
						},
						store,
					});
				}

				if ($('.saved-searches').length) {
					savedViewsList = new Vue({
						el: '.saved-searches',
						name: 'SavedSearchesApp',
						components: {
							SavedViewsList,
						},
						store,
					});
				}

				$(document).one('pjax:end', () => {
					if (saveViewForm) {
						saveViewForm.$destroy();
					}

					if (savedViewsList) {
						savedViewsList.$destroy();
					}
				});
			}
		},
		onClose: function () {
			datatable.refresh();
		},
	});

	$(document).one('pjax:end', () => {
		datatable.refresh();
	});

	const exportActionButton = document.getElementById('export-action');

	if (exportActionButton) {
		new Vue({
			el: exportActionButton,
			name: 'ExportActionButtonApp',
			components: {
				'export-action-dropdown': ExportActionDropdown,
			},
		});
	}
}
